module.exports = __webpack_public_path__ + "static/media/View Blue.5f2341ae.svg";